
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"9.1 5 7.17 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.982 9.88l4.59-4.59a1 1 0 011.41 0 1 1 0 010 1.42l-4.6 4.58a1 1 0 000 1.42l4.6 4.58a1 1 0 01-1.41 1.42l-4.59-4.59a3 3 0 010-4.24z","data-original":"#000000"}})])
          )
        }
      }
    